import React from 'react'

export function useOutsideWindowClick(onClick: () => void) {
    React.useEffect(() => {
        for (const iframe of document.getElementsByTagName('iframe')) {
            iframe.contentDocument?.addEventListener('click', onClick)
        }

        return () => {
            for (const iframe of document.getElementsByTagName('iframe')) {
                iframe.contentDocument?.removeEventListener('click', onClick)
            }
        }
    }, [onClick])
}
